import React from "react";
import { Dialog, DialogTitle } from "@mui/material";
import FacilitiesApi from "../../../../Classes/API/Administration/FacilitiesApi";
import { useEffect, useState } from "react";
import AddManyToManyReq from "../../../../Classes/Models/Requests/AddManyToManyReq";
import SearchFacilitiesReq from "../../../../Classes/Models/Requests/Administration/CreateFacilityReq";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import AsyncSelect from "react-select/async";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import Swal from "sweetalert2";
const AddFacilityModal = ({ ShowModal, AccSession, EnableModal, setIsLoaded }) => {
  const [FacilitySearch, setFacilitySearch] = useState();
  const [FacilityId, setFacilityId] = useState("");
  const [ShowLoading, setShowLoading] = useState(false);
  const GetFacilities = async () => {
    let searchReq = new SearchFacilitiesReq();
    searchReq.Name = FacilitySearch;
    let res = await FacilitiesApi.SearchFacilities(searchReq);
    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({
          value: item.id,
          label: item.name + ", TYPE: " + item.getFacilityType.typeName,
        });
      });
      return optionsArr;
    }
  };
  const AddToSession = async (id) => {
    let addReq = new AddManyToManyReq();
    addReq.Id1 = AccSession.id;
    addReq.Id2 = id;
    let res = await SessionsApi.AddFacilityToAccountingSession(addReq);
    EnableModal(false, {});
    if (res.status == "Success") {
      Swal.fire({
        icon: "success",
        title: "Facility Added",
        text: "Facility has been added to the session",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res.message,
      });
    }
  };
  const RemoveFromSession = async (id) => {
    setShowLoading(true);
    let removeReq = new SearchStringOrIntReq();
    removeReq.SearchInt = id;
    let res = await SessionsApi.RemoveFacilityFromAccountingSession(removeReq);
    EnableModal(false, {});
    if (res.status == "Success") {
      Swal.fire({
        icon: "success",
        title: "Facility Removed",
        text: "Facility has been removed from the session",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res.message,
      });

      console.log(res);
    }
  };
  return (
    <Dialog
      open={ShowModal}
      onClose={() => EnableModal(false, {})}
      maxWidth={"md"}
      fullWidth
      PaperProps={{
        sx: {
          width: "100%",
          maxHeight: 600,
          height: "100%",
        },
      }}
    >
      {ShowLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "6000px", width: "300px" }}
        >
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : (
        <div className="AddFacilityModal">
          <div className="FacilityModalHeader">
            Add Facility to {AccSession.sessionName} Session ID: {AccSession.id} <br /> Patient:{" "}
            {AccSession.patientName}
          </div>
          <div className="FacilityModalBody">
            <div className="FacilityModalBodyTop">
              <AsyncSelect
                isClearable={true}
                loadOptions={GetFacilities}
                onInputChange={setFacilitySearch}
                onChange={(e) => setFacilityId(e ? e.value : "")}
              />
              <button className="btn btn-outline-success" onClick={() => AddToSession(FacilityId)}>
                + Add
              </button>
            </div>
            <div className="FacilityModalBodyBottom">
              {AccSession.getSessionFacilities?.map((item) => {
                return (
                  <div className="FacilityModalBodyBottomItem">
                    <span>{item.getFacility.name}</span>
                    <button
                      onClick={() => RemoveFromSession(item.id)}
                      className="btn btn-outline-danger"
                    >
                      X
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default AddFacilityModal;
